import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["maskProps"],
  _excluded2 = ["presetMask", "keepCharPositions"];
import React from "react";
import { getPresetMaskConfig } from "./logic";
import { BaseMaskedTextInput } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var MaskedInput = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var maskProps = _ref.maskProps,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var presetMask = maskProps.presetMask,
    _maskProps$keepCharPo = maskProps.keepCharPositions,
    keepCharPositions = _maskProps$keepCharPo === void 0 ? true : _maskProps$keepCharPo,
    restMaskProps = _objectWithoutProperties(maskProps, _excluded2);
  if (presetMask) {
    var presetConfig = getPresetMaskConfig(presetMask);
    return /*#__PURE__*/_jsx(BaseMaskedTextInput, _extends({
      keepCharPositions: keepCharPositions,
      ref: forwardedRef
    }, restProps, presetConfig));
  }
  return /*#__PURE__*/_jsx(BaseMaskedTextInput, _extends({
    keepCharPositions: keepCharPositions,
    ref: forwardedRef
  }, restMaskProps, restProps));
});
MaskedInput.displayName = "MaskedInput";
export default MaskedInput;